/* Stylesheet */

.chart_legend {
  .row {
    padding: 52px 0px 0px 0px;

    .col {
      padding: 0;
      display: flex;
      align-items: center;
    }

    .chart_col {
      justify-content: flex-end;
    }
  }
}
